import './App.scss';
import React from 'react';
import { Route, Routes, BrowserRouter } from "react-router-dom";
import './global.scss';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme';
import ConfigProvider from './common/ConfigProvider';
import ScrollToTop from './common/ScrollToTop';
import AlertNotificationContainer from "./common/AlertNotificationContainer";
import CustomerPage from './pages/Customer/CustomerPage';
import AdminPage from './pages/Admin/AdminPage';

const basename = process.env.PUBLIC_URL || '/';

const App = () => {
  return <ConfigProvider>
    <ThemeProvider theme={theme}>
      <BrowserRouter basename={basename}>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/*" element={<AdminPage />} />
          <Route path="/*" element={<CustomerPage />} />
        </Routes>
      </BrowserRouter>
      <AlertNotificationContainer />
    </ThemeProvider>
  </ConfigProvider>
}

export default App;